<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="book"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $t('agreements') }}
        </div>
      </template>

      <v-row class="mx-0">
        <v-col cols="6">
          <filter-main
            :filter-options="filterOptions"
            :filter-actions="filterActions"
            :filter="filter"
            @set-filter="setFilter"
          />
        </v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
          @blur="getDataFromApi"
          @keydown.enter="getDataFromApi"
        />
      </v-row>

      <v-divider class="my-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
      >
        <template v-slot:body.prepend>
          <filter-row
            :filter-options="filterOptions"
            :headers="headers"
            :filter="filter"
            @set-filter="setFilter"
          />
        </template>
        <template v-slot:item.name="{ item }">
          {{ item.name.substring(0, 125) }} {{ item.name.length > 125 ? "..." : "" }}
        </template>
        <template v-slot:item.carrier.slug="{ item }">
          {{ item.carrier.name }}
        </template>
        <template v-slot:item.active="{ item }">
          <v-chip
            text-color="white"
            :color="isExpired(item) ? 'red' : 'green'"
          >
            {{ item.valid_from_date }} <v-icon>mdi-arrow-right</v-icon> {{ item.valid_to_date }}
          </v-chip>
        </template>
        <template v-slot:item.file="{ item }">
          <v-btn
            target="_blank"
            small
            :href="'https://s3.eu-central-1.amazonaws.com/cr-admin/'+ encodeURIComponent(item.file)"
          >
            <i class="material-icons">attach_file</i> Åben
          </v-btn>
        </template>
        <template v-slot:item.action="{ item }">
          <v-row justify="end">
            <v-icon
              medium
              color="orange"
              class="mr-2"
              @click="duplicateItem(item)"
            >
              mdi-book-multiple
            </v-icon>
            <v-icon
              medium
              class="mr-5"

              color="green"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              medium
              color="red"
              class="mr-5"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </v-row>
        </template>
      </v-data-table>
      <v-col>
        <v-row>
          <v-btn
            color="green"
            class="ml-auto mt-5"
            @click="editItem({id: null})"
          >
            <v-icon class="mr-3">
              mdi-plus
            </v-icon>
            {{ $t('new') }}
          </v-btn>
        </v-row>
      </v-col>
    </base-material-card>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'
  import moment from 'moment'
  export default {
    mixins: [List],

    data (vm) {
      return {
        endpoint: 'agreements',
        name: 'agreement',
        headers: [
          {
            sortable: false,
            text: this.$t('name'),
            value: 'name',
            width: '100%',

          },
          {
            text: this.$t('carrier'),
            value: 'carrier.slug',
          },
          {
            text: this.$t('currency'),
            value: 'currency.name',
          },
          {
            text: this.$t('active'),
            value: 'active',
          },
          {
            text: this.$t('file'),
            value: 'file',
          },
          { text: this.$t('actions'), value: 'action', sortable: false },

        ],
        editedItem: {
          name: '',
          slug: '',
          erp_id: '',
          volume_weight_factor: '',
        },
        defaultItem: {
          name: '',
          slug: '',
          erp_id: '',
          volume_weight_factor: '',
        },
        filterOptions: {
          name: {
            label: this.$t('name'),
            type: 'free',
            filter: '',
          },
          'carrier.slug': {
            label: this.$t('carrier'),
            type: 'multi',
            options: vm.$store.state.carriers,
            filter: [],
          },
        },
      }
    },
    methods: {
      isExpired (agreement) {
        if (moment().isAfter(moment(agreement.valid_to_date, 'DD-MM-YYYY'))) { return true }

        return false
      },
      editItem: function ({ id }) {
        this.$router.push(`/carrier-agreements/details/${id}`)
      },
      duplicateItem ({ id }) {
        if (confirm(this.$t('confirm_duplicate', { type: this.$t(this.name).toLowerCase() }))) {
          this.$post(`/agreements/duplicate/${id}`).then(r => {
            this.getDataFromApi()

            this.$toast(`${this.$t(this.name)} ${this.$t('duplication_correctly')}`)
          })
        }
      },
    },
  }
</script>
